"use strict";var t;(function(i){i.age="age",i.height="height",i.weight="weight",i.bust="bust",i.nationality="nationality"})(t||(t={}));export{t as ParameterType};
